import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  success: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    height: 50,
  },

  error: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    height: 50,
  },

  message: {
    display: 'flex',
    alignItems: 'center'
  },

  iconVariant: {
    marginRight: 10
  },

  closeIcon: {
    color: theme.palette.primary.contrastText,
  }
}));
